import { CREATE_POST } from "shared/api";
import { Form, MediaSlidesField, Page, RadiosField, SubmitButton, TextAreaField, useNavigator } from "shared/react";
import { POST_FORM_SCHEMA } from "shared/schema";
import { ProfileButton } from "../entity/EntityButton.js";
import { callAPI } from "../util/api.js";
import { useUserItem } from "../util/data.js";
import { uploadMediaFile } from "../util/media.js";
import { USER } from "../util/user.js";

export function PostCreatePage(): React.ReactElement {
	const privacy = useUserItem().data.postPrivacy;
	const nav = useNavigator();
	return (
		<Page title="Create post">
			<header>
				<h1>Create post</h1>
			</header>
			<Form
				schema={POST_FORM_SCHEMA}
				data={{ privacy }}
				onSubmit={async v => {
					const id = await callAPI(CREATE_POST, v);
					nav.redirect(`/post/${id}`);
				}}
			>
				<article>
					<header className="color-quiet size-small space-xsmall flex-row flex-left gap-xsmall">
						<ProfileButton uid={USER.data.uid} />
						<span className="link">just now</span>
						<span className="link">0 replies</span>
					</header>
					<MediaSlidesField name="images" uploader={uploadMediaFile} title="" />
					<section>
						<TextAreaField name="content" rows={3} title="" placeholder="Write your post..." />
					</section>
				</article>
				<footer>
					<RadiosField name="privacy" title="" />
					<SubmitButton>Create post</SubmitButton>
				</footer>
			</Form>
		</Page>
	);
}
